import React, { useRef, useState } from "react";
import QuoteModal from "../QuoteModal/index.tsx";

export function Hero() {
  const [quoteOpen, setQuoteOpen] = useState(false);
  const quoteBtnRef = useRef(null);

  const openModal = () => setQuoteOpen(true);
  const closeModal = () => {
    setQuoteOpen(false);
    setTimeout(() => quoteBtnRef.current?.focus(), 0);
  };

  return (
    <section className="hero">
      <div className="container hero__grid">
        <div className="hero__copy">
          <h1 className="hero__title">
           Track Attendance -<span className="u-nowrap"> Anywhere.<br/> No Internet Needed</span>
          </h1>
          <p className="hero__subtitle">
            Track attendance anywhere—no internet required. Built for
            remote sites and field teams. Syncs automatically when back online.
          </p>
          <div className="hero__cta">
            <button
              ref={quoteBtnRef}
              type="button"
              className="btn btn--primary"
              onClick={openModal}
            >
              Request Demo
            </button>

            <a href="#devices" className="btn btn--ghost">See device options</a>
          </div>
          <ul className="hero__bullets">
            <li>Works 100% offline • secure local storage</li>
            <li>Tablet & mobile friendly</li>
            <li>Prevents buddy punching • accurate timesheets</li>
          </ul>
        </div>

        <div className="hero__art" aria-hidden="true">
          <div className="device device--tablet" />
          <div className="device device--phone" />
          <div className="badge">Offline ✓</div>
        </div>
      </div>

      {/* Modal lives here */}
      <QuoteModal open={quoteOpen} onClose={closeModal} />
    </section>
  );
}
